import React, { useState } from "react";

export default function RejectRequestModal({
  isOpen,
  onClose,
  onContinue,
  remark,
  setRemark,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-md shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold text-[#035C98] mb-2">
          Reject Request
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to reject the purchase order for ‘Master Bond
          Name’? <br />
          Please add remark for this
        </p>

        <textarea
          className="w-full border border-gray-300 rounded-md p-2 text-sm placeholder-gray-400 resize-none mb-6"
          rows={4}
          placeholder="Add Remark"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          required
        />

        <div className="flex justify-between">
          <button
            onClick={() => onClose(false)}
            className="px-6 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Back
          </button>

          <button
            onClick={() => onContinue("reject")}
            className="px-6 py-2 rounded-md bg-red-600 text-white hover:bg-red-700"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
